import { render, staticRenderFns } from "./BlujayChainDetail.vue?vue&type=template&id=28481644&scoped=true&"
import script from "./BlujayChainDetail.vue?vue&type=script&lang=js&"
export * from "./BlujayChainDetail.vue?vue&type=script&lang=js&"
import style0 from "./BlujayChainDetail.vue?vue&type=style&index=0&id=28481644&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28481644",
  null
  
)

export default component.exports